<svelte:options accessors={true} />

<script>
    export let name = 'Order'
    export let value = 0
    export let account = 0
</script>

<iframe src="https://yoomoney.ru/quickpay/button-widget?targets={encodeURIComponent(name)}&default-sum={value}&button-text=12&any-card-payment-type=on&button-size=m&button-color=orange&successURL=&quickpay=small&account={account}&" width="184" height="36" frameborder="0" allowtransparency="true" scrolling="no"></iframe>
<br/>
<small>
    Обычно платеж проходит за 1-10 минут
</small>
